import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { generatePromoCodesOriginalityUrl } from '../../../../app.urls';
import { FileService } from '../../../../services/file.service';
import { first } from 'rxjs/operators';
import { PromocodeBase } from '../../promocode-base';

@Component({
  selector: 'smart-promocode-section',
  templateUrl: './promocode-section.component.html',
  styleUrls: ['./promocode-section.component.scss']
})
export class PromocodeSectionComponent extends PromocodeBase implements OnInit {
  promoGenerateForm: FormGroup;

  loading = false;

  constructor(
    private _fb: FormBuilder,
    protected fileService: FileService
  ) {
    super();
  }

  ngOnInit() {
    this.promoGenerateForm = this._fb.group({
      count: ['', [Validators.required, Validators.min(1), Validators.max(1000)]]
    });
  }

  submit() {
    this.promocode.type = 'cash';
    this.generatePromoCodes();
  }

  generatePromoCodes() {
    this.loading = true;
    this.fileService
      .downloadPost(generatePromoCodesOriginalityUrl(this.promoGenerateForm.get('count').value), this.promocode)
      .pipe(first())
      .subscribe();
  }

}
